(() => {
    const perksSliders = document.querySelectorAll('.perks-gallery-container');

    perksSliders.forEach((sliderNode) => {
        let container = sliderNode.querySelector('.slider-block');

        tns({
            container,
            fixedWidth	: 208,
            loop: true,
            items: 1,
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 3000,
            autoplayButton: false,
            autoplayButtonOutput: false,
            mouseDrag: true,
            controlsContainer: sliderNode.querySelector('.slider-arrows'),
            navContainer: sliderNode.querySelector('.slider-dots'),
            controls: false,
            nav: true,
            freezable: false,
            center: true,
            gutter: 32,
            responsive: {
                768: {
                    center: false,
                    nav: false,
                    controls: true,
                }
            }
        });
    });
})();